import Thumb from './thumb';
export default class ThumbFont extends Thumb {
  constructor (parameters) {
    super();
    this.type = 'Font';

    // Make this undefined for this item
    this.height = null;
    this.width = null;

    this.fontFamily = null;
    this.fontSize = 22;
    this.text = 'Type text here';

    this.setValues(parameters);
  }

  getItem () {
    const $container = this.getItemContainer();

    const size = this.fontSize > 50 ? this.fontSize / 2 : this.fontSize;
    $container.find('a').append('<a role="menuitem" style="white-space: nowrap;overflow: hidden; max-width: 230px; background-color: transparent !important; font-size:' + size + 'px; font-family: ' + this.fontFamily + ';">' + this.text + '</a>');

    return $container;
  }

  onItemClick (item) {
    const editor = INKIVE.Tool.getInstance().editor;

    const font = {
      family: this.fontFamily,
      size: this.fontSize,
      text: this.text
    };

    const offset = editor.getOffset();
    const zoom = INKIVE.EditorFacade.handle('zoom', 'get');
    const containerWidth = this.getItemContainer().get(0).getBoundingClientRect().width;
    const width = Math.floor4(font.text.length > 30 ? offset.width / 2 : containerWidth / zoom);

    const attr = {
      x: (offset.width - width) / 2,
      y: Math.floor4((offset.height - font.size) / 2),
      width,
      text: {
        font_family: font.family,
        font_size: font.size,
        textContent: font.text
      }
    };

    INKIVE.Tool.blinkScreen(editor.addElement('textarea', attr));
  }

  onItemRelease (item, e) {
    const editor = INKIVE.Tool.getInstance().editor;

    const font = {
      family: this.fontFamily,
      size: this.fontSize,
      text: this.text
    };

    const zoom = INKIVE.EditorFacade.handle('zoom', 'get');
    const offset = editor.getOffset();
    const bbRect = item.getBoundingClientRect();
    const containerWidth = this.getItemContainer().get(0).getBoundingClientRect().width;
    const width = Math.floor4(font.text.length > 30 ? offset.width / 2 : containerWidth / zoom);

    const attr = {
      x: Math.floor4(e.clientX - (width / 2) * zoom - offset.x),
      y: Math.floor4((bbRect.top - offset.y) / zoom),
      width,
      text: {
        'font-family': font.family,
        'font-size': font.size,
        textContent: font.text
      }
    };

    INKIVE.Tool.blinkScreen(editor.addElement('textarea', attr));
  }
}
